// extracted by mini-css-extract-plugin
export default {"screenTransition":"App_screenTransition__Uz8mA"};